import Model from 'core/model/Model';

class FeedbackModel extends Model {
  get urlRoot() {
    return '/api/ui/kaizen/feedback';
  }
}

export default FeedbackModel;
